import React from 'react'
import cn from 'classnames'
import styles from './Steps.module.sass'
import ScrollParallax from '../../ScrollParallax'

const items = [
  {
    title: 'Sign up',
    color: '#3772FF',
    images: 'img/icon-download.svg',
    content:
      'Login with your Github account, and apply to be part of Jungle Program as a Guardian and earn money.',
  },
  {
    title: 'Review',
    color: '#9506CE',
    images: 'img/icon-user.svg',
    content: 'Give us some time to review your application. We’ll be in touch with you very soon!',
  },
  {
    title: 'Invitation',
    color: '#E00054',
    images: 'img/icon-email.svg',
    content:
      'Once approved, you’ll receive an invite to fill in your skillset, and join the community of Guardians.',
  },
  {
    title: 'Start earning',
    color: '#F5A70B',
    images: 'img/icon-wallet.svg',
    content:
      'You’ll get matched with developers who need guidance and support within your expertise.',
  },
]

export const Steps = ({ scrollToRef }) => {
  return (
    <div className={cn('section', styles.section)} ref={scrollToRef}>
      <div className={cn('container', styles.container)}>
        <div className={styles.head}>
          <h2 className={cn('h2', styles.title)}>How to become a Guardian</h2>
          <div className={styles.info}>Enroll & join the network of Guardians</div>
        </div>
        <div className={styles.list}>
          {items.map((x, index) => (
            <ScrollParallax className={styles.item + ' ' + 'safari-border-fix'} key={index}>
              <div className={styles.preview} style={{ backgroundColor: x.color }}>
                <img src={x.images} alt={`Step ${index}`} />
              </div>
              <div className={styles.number}>Step {index}</div>
              <div className={styles.subtitle}>{x.title}</div>
              <div className={styles.content}>{x.content}</div>
            </ScrollParallax>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Steps
